import './App.css';
import React, { useEffect, useState, useCallback } from "react";

//var freezepage = false;

//var selectedCategory = '1'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      //selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function Challenges() { 
const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000

const [showCreateChallenge, setShowCreateChallenge] = useState(false);

const [activeChallenges, setActiveChallenges] = useState([]);
const [inactiveChallenges, setInactiveChallenges] = useState([]);
const [showActive, setShowActive] = useState(true);

const [friends, setFriends] = useState([]);
const [startDate, setStartDate] = useState('');
const [startTime, setStartTime] = useState('');
const [timer, setTimer] = useState(15);
const [selectedCategory, setSelectedCategory] = useState('1'); // Default category
const [categories, setCategories] = useState([]); // Initialize categories


// Show disclaimer popup on page load
useEffect(() => {
  const showDisclaimer = () => {
    const disclaimer = document.createElement('div');
    disclaimer.style.position = 'fixed';
    disclaimer.style.top = '0';
    disclaimer.style.left = '0';
    disclaimer.style.width = '100%';
    disclaimer.style.height = '100%';
    disclaimer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    disclaimer.style.display = 'flex';
    disclaimer.style.justifyContent = 'center';
    disclaimer.style.alignItems = 'center';
    disclaimer.style.zIndex = '1000';

    const modal = document.createElement('div');
    modal.style.backgroundColor = '#fff';
    modal.style.padding = '24px';
    modal.style.borderRadius = '8px';
    modal.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
    modal.style.textAlign = 'center';
    modal.style.maxWidth = '400px';

    const title = document.createElement('h2');
    title.innerText = 'Disclaimer';
    title.style.marginBottom = '16px';

    const message = document.createElement('p');
    message.innerHTML = `
      <p style="text-align: left;"><strong>Group Challenges:</strong></p>
      <ul style="text-align: left;">
      <li>Group challenges are private, and only the organiser can invite friends to participate.</li>
      <li>The challenge duration is determined based on the number of questions selected, with each question allotted 1 minute.</li>
      </ul>
      <p style="text-align: left;"><strong>Open Challenges:</strong></p>
      <ul style="text-align: left;">
      <li>Open challenges are public and open to all participants.</li>
      <li>These challenges remain open for an extended period, calculated as 5 minutes per question, to encourage greater participation.</li>
      <li>Individual questions will still adhere to their standard time limits.</li>
      </ul>
      <p style="text-align: left;"><strong>Winner:</strong></p>
      <ul style="text-align: left;">
      <li>The winner is awarded the cumulative score earned by all participants.</li>
      <li>If there is no definitive winner (i.e., multiple participants achieve the same highest score), the challenge will be declared a draw, and no points will be awarded to any participant.</li>
      </ul>
    `;
    message.style.marginBottom = '24px';

    const agreeButton = document.createElement('button');
    agreeButton.innerText = 'Agree';
    agreeButton.style.padding = '8px 16px';
    agreeButton.style.marginRight = '8px';
    agreeButton.style.backgroundColor = '#007BFF';
    agreeButton.style.color = '#fff';
    agreeButton.style.border = 'none';
    agreeButton.style.borderRadius = '4px';
    agreeButton.style.cursor = 'pointer';

    const cancelButton = document.createElement('button');
    cancelButton.innerText = 'Cancel';
    cancelButton.style.padding = '8px 16px';
    cancelButton.style.backgroundColor = '#dc3545';
    cancelButton.style.color = '#fff';
    cancelButton.style.border = 'none';
    cancelButton.style.borderRadius = '4px';
    cancelButton.style.cursor = 'pointer';

    agreeButton.onclick = () => {
      document.body.removeChild(disclaimer);
    };

    cancelButton.onclick = () => {
      window.location.href = "/?pageName=Profile&userid=" + currentuserid;    };

    modal.appendChild(title);
    modal.appendChild(message);
    modal.appendChild(agreeButton);
    modal.appendChild(cancelButton);
    disclaimer.appendChild(modal);
    document.body.appendChild(disclaimer);
  };

  showDisclaimer();
}, []);


// Fetch friends from the database
useEffect(() => {
  const fetchFriends = async () => {
    try {
      const response = await fetch(KC_SERVICE + '/friends_getConfirmedFriends', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Fetched friends:', result);

      setFriends(result.ConfirmedFriends || []);
    } catch (error) {
      console.error('Error fetching friends:', error);
    }
  };

  fetchFriends();
}, [KC_SERVICE]);

// Fetch categories from the database
useEffect(() => {
  const fetchCategories = async () => {
    try {
      const response = await fetch(KC_SERVICE + '/category_getActiveList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Fetched categories:', result);

      setCategories(result.Categories || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };
  fetchCategories();
}, [KC_SERVICE]);

// Fetch challenges from the database
const fetchChallenges = useCallback(async () => {
  try {
    const response = await fetch(KC_SERVICE + '/challenges_getChallenges', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const challenges = await response.json();
    const challengeArray = challenges.Challenges;
    console.log('Fetched challenges:', challengeArray);

    if (Array.isArray(challengeArray)) {
      setActiveChallenges(
        challengeArray.filter(challenge => 
          challenge.active === true &&
          new Date() <= new Date(`${challenge.enddate}T${challenge.endtime}`)
        )
      );
      setInactiveChallenges(
        challengeArray.filter(challenge => 
          (
            challenge.active === false || 
            (new Date() > new Date(`${challenge.enddate}T${challenge.endtime}`))
          )
        )
      );
    } else {
      console.error('Unexpected response format: challenges is not an array', challenges);
    }
  } catch (error) {
    console.error('Error fetching challenges:', error);
  }
}, [KC_SERVICE]);

useEffect(() => {
  fetchChallenges();
}, [KC_SERVICE, fetchChallenges]);

function RenderChallengesTable(challenges, isActive) {
  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRowExpansion = (index) => {
    setExpandedRows((prevExpandedRows) =>
      prevExpandedRows.includes(index)
        ? prevExpandedRows.filter((rowIndex) => rowIndex !== index)
        : [...prevExpandedRows, index]
    );
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
        <button
          style={{
            padding: '8px 16px',
            cursor: 'pointer',
            backgroundColor: '#007BFF',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
          }}
          onClick={() => fetchChallenges()}
        >
          Refresh
        </button>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '16px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
        <thead style={{ backgroundColor: '#007BFF', color: '#fff' }}>
          <tr>
            <th style={{ border: '1px solid #ccc', padding: '12px', textAlign: 'left' }}>Name</th>
            <th style={{ border: '1px solid #ccc', padding: '12px', textAlign: 'left' }}>Category</th>
            <th style={{ border: '1px solid #ccc', padding: '12px', textAlign: 'left' }}>Questions</th>
            <th style={{ border: '1px solid #ccc', padding: '12px', textAlign: 'left' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {challenges.map((challenge, index) => {
            const isExpanded = expandedRows.includes(index);
            return (
              <React.Fragment key={index}>
              <tr
                style={{
                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
                cursor: 'pointer',
                }}
                onClick={() => toggleRowExpansion(index)}
              >
                <td style={{ border: '1px solid #ccc', padding: '12px' }}>
                <button
                  style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  marginRight: '8px',
                  }}
                  onClick={(e) => {
                  e.stopPropagation();
                  toggleRowExpansion(index);
                    }}
                  >
                    {isExpanded ? '▼' : '▶'}
                  </button>
                  {challenge.name}
                  </td>
                  <td style={{ border: '1px solid #ccc', padding: '12px' }}>{challenge.Category.CategoryName}</td>
                  <td style={{ border: '1px solid #ccc', padding: '12px' }}>{challenge.questioncount}</td>
                  <td style={{ border: '1px solid #ccc', padding: '12px' }}>
                  {!isActive ? (
                    <>
                    <button
                    style={{
                    padding: '8px 16px',
                    cursor: 'pointer',
                    backgroundColor: '#6c757d',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    marginRight: '8px',
                    }}
                    onClick={(e) => {
                    e.stopPropagation();
                    window.location.href = window.location.pathname + `?cid=${challenge.id}&userid=${currentuserid}&pageName=cview`;
                    }}
                  >
                    View
                  </button>
                  {!challenge.winnerid && (
                    <button
                    style={{
                      padding: '8px 16px',
                      cursor: 'pointer',
                      backgroundColor: '#17a2b8',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                    }}
                    onClick={async (e) => {
                      e.stopPropagation();
                      try {
                      const response = await fetch(KC_SERVICE + '/challenges_setwinner', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ challengeId: challenge.id }),
                      });

                      if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                      }

                      console.log('Winner set successfully:', response);
                      window.location.reload();
                      } catch (error) {
                      console.error('Error setting winner:', error);
                      }
                    }}
                    >
                    Show Winner
                    </button>
                  )}
                  </>
                ) : Array.isArray(challenge.participant_count) && challenge.participant_count.some(participant => String(participant.participantid) === String(currentuserid.split('-')[0])) ? (
                  <button
                  style={{
                    padding: '8px 16px',
                    cursor: 'pointer',
                    backgroundColor: '#28a745',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.location.href = window.location.pathname + `?cid=${challenge.id}&userid=${currentuserid}&pageName=cview`;
                  }}
                  >
                  Start
                  </button>
                ) : (
                  <button
                  style={{
                    padding: '8px 16px',
                    cursor: 'pointer',
                    backgroundColor: '#007BFF',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                  }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    try {
                    const response = await fetch(KC_SERVICE + '/challenges_joinChallenge', {
                      method: 'POST',
                      headers: {
                      'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                      challengeId: challenge.id,
                      joinerId: currentuserid.split('-')[0],
                      }),
                    });

                    if (!response.ok) {
                      throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const result = await response.json();
                    console.log('Joined challenge successfully:', result);
                    window.location.reload();
                    } catch (error) {
                    console.error('Error joining challenge:', error);
                    }
                  }}
                  >
                  Join
                  </button>
                )}
                </td>
              </tr>
              {isExpanded && (
                <tr>
                <td colSpan="4" style={{ border: '1px solid #ccc', padding: '12px', backgroundColor: '#f1f1f1' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <strong>Organizer:</strong> {challenge.Organizer.username}
                  </div>
                  <div>
                    <strong>Participants:</strong> {challenge.participant_count.length}
                  </div>
                  <div>
                    <strong>Type:</strong> {challenge.type}
                  </div>
                  <div>
                    <strong>Ends At:</strong> {challenge.enddate} {challenge.endtime}
                  </div>
                  <div>
                    <strong>Winner:</strong> {challenge.Winner ? challenge.Winner.username : ''}
                  </div>
                  </div>
                </td>
                </tr>
              )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function renderCreateChallengeModal(friends, setFriends, startDate, setStartDate, startTime, setStartTime, timer, setTimer) {

  return (
    <div style={{ border: '1px solid #ccc', padding: '16px', marginBottom: '16px', position: 'relative' }}>
      <button
        onClick={() => setShowCreateChallenge(false)}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'none',
          border: 'none',
          fontSize: '16px',
          cursor: 'pointer',
        }}
      >
        X
      </button>
      <h2>Create New Challenge</h2>
      <div style={{ display: 'flex', gap: '32px', marginBottom: '16px' }}>
        <div style={{ display: 'none' }}>
          <label style={{ display: 'block', marginBottom: '8px' }}>Start Date:</label>
          <input
            type="date"
            value={startDate || new Date().toISOString().split('T')[0]}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ padding: '8px', width: '100%' }}
          />
        </div>
        <div style={{ display: 'none' }}>
          <label style={{ display: 'block', marginBottom: '8px' }}>Start Time:</label>
          <input
            type="time"
            value={
              startTime ||
              new Date(new Date().getTime() + 0 * 60 * 1000)
                .toLocaleTimeString('en-US', { hour12: false, timeZone: 'Asia/Kolkata' })
                .slice(0, 5)
            }
            onChange={(e) => setStartTime(e.target.value)}
            style={{ padding: '8px', width: '100%' }}
          />
        </div>
        <div style={{ display: 'none' }}>
          <label style={{ display: 'block', marginBottom: '8px' }}>Timer (seconds):</label>
          <select
            value={timer}
            onChange={(e) => setTimer(Number(e.target.value))}
            style={{ padding: '8px', width: '100%' }}
          >
            <option value={15}>15</option>
            <option value={30}>30</option>
            <option value={45}>45</option>
            <option value={60}>60</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '8px' }}>Category:</label>
          <select
            name="categorylist"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{ padding: '8px', width: '100%' }}
          >
            {categories.map((category, index) => (
              <option key={index} value={category.id}>
                {category.CategoryName}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>Challenge Name:</label>
        <input
          type="text"
          placeholder="Enter challenge name"
          style={{ padding: '8px', width: '30%' }}
        />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>Question Count:</label>
        <select
          name="questionCount"
          style={{ padding: '8px', width: '30%' }}
        >
          {[...Array(10)].map((_, i) => {
            const value = (i + 1) * 10;
            return (
              <option key={value} value={value}>
                {value}
              </option>
            );
          })}
        </select>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>Challenge Type:</label>
        <div>
          <label style={{ marginRight: '16px' }}>
            <input
              type="radio"
              name="challengeType"
              value="group"
              defaultChecked
              style={{ marginRight: '8px' }}
            />
            Closed Group Challenge
          </label>
          <label>
            <input
              type="radio"
              name="challengeType"
              value="open"
              style={{ marginRight: '8px' }}
            />
            Open Challenge
          </label>
        </div>
      </div>

      <h2>Friends</h2>
      <ul style={{ listStyleType: 'none', padding: 0 }}>
        {friends.map((friend, index) => (
          <li key={index} style={{ marginBottom: '8px' }}>
            <label>
              <input
                type="checkbox"
                style={{ marginRight: '8px' }}
                onChange={(e) => {
                  const updatedFriends = [...friends];
                  updatedFriends[index].selected = e.target.checked;
                  setFriends(updatedFriends);
                }}
              />
              {friend.Users.username}
            </label>
          </li>
        ))}
      </ul>
      <button
        onClick={async () => {
          const participantIds = friends.filter(friend => friend.selected).map(friend => friend.Users.userid);
          const organizerId = currentuserid.split('-')[0]; // Replace with actual organizer ID
          const questionCount = parseInt(document.querySelector('select[name="questionCount"]').value, 10); // Get selected question count
          const challengeType = document.querySelector('input[name="challengeType"]:checked').value; // Get selected challenge type

          try {
            const response = await fetch(KC_SERVICE + '/challenges_createChallenge', {
              method: 'POST',
              headers: {
              'Content-Type': 'application/json',
              },
              body: JSON.stringify({
              participantIds,
              startDate: startDate || new Date().toISOString().split('T')[0], // Use default value if blank
              startTime: startTime || 
                new Date(new Date().getTime() + 0 * 60 * 1000)
                .toLocaleTimeString('en-US', { hour12: false, timeZone: 'Asia/Kolkata' })
                .slice(0, 5), // Use default value if blank
                timer,
                categoryId: parseInt(document.querySelector('select[name="categorylist"]').value, 10), // Get selected category ID from dropdown
              organizerId,
              name: document.querySelector('input[type="text"]').value || 'New Challenge', // Default name if blank
              questionCount, // Include selected question count
              type: challengeType, // Include selected challenge type
              }),
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log('Challenge created successfully:', result);
            setShowCreateChallenge(false);
            fetchChallenges();
          } catch (error) {
            console.error('Error creating challenge:', error);
          }
        }}
        style={{
          marginTop: '16px',
          padding: '8px 16px',
          backgroundColor: '#007BFF',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Create Challenge
      </button>
    </div>
  );
}

return (
  <div style={{ padding: '24px', maxWidth: '100%', boxSizing: 'border-box' }}>
    <h1 style={{ fontSize: '1.5rem', textAlign: 'center', marginBottom: '0' }}>Challenges</h1>
    <div></div>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: showCreateChallenge ? '0' : '16px' }}>
      <div style={{ display: 'flex', gap: '0px', border: '1px solid #007BFF', borderRadius: '4px', overflow: 'hidden', height: '100%' }}>
        <button
          style={{
            padding: '12px 24px',
            backgroundColor: showActive ? '#007BFF' : '#6c757d',
            color: showActive ? '#fff' : '#000',
            border: 'none',
            cursor: 'pointer',
            flex: 1,
            fontSize: '1rem',
            height: '100%',
          }}
          onClick={() => setShowActive(true)}
        >
          Current
        </button>
        <button
          style={{
            padding: '12px 24px',
            backgroundColor: !showActive ? '#007BFF' : '#6c757d',
            color: !showActive ? '#fff' : '#000',
            border: 'none',
            cursor: 'pointer',
            flex: 1,
            fontSize: '1rem',
            height: '100%',
          }}
          onClick={() => setShowActive(false)}
        >
          History
        </button>
      </div>
      <button
        style={{
          padding: '10px 20px',
          backgroundColor: '#28a745',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          fontSize: '1rem',
          height: '100%',
        }}
        onClick={() => setShowCreateChallenge(true)}
      >
        + Create New
      </button>
    </div>
    {showActive
      ? RenderChallengesTable(activeChallenges, true)
      : RenderChallengesTable(inactiveChallenges, false)
    }

    {showCreateChallenge && 
      renderCreateChallengeModal(friends, setFriends, startDate, setStartDate, startTime, setStartTime, timer, setTimer)
    }
  </div>
);
}

export default Challenges;